import { render, staticRenderFns } from "./PageNotificationsView.vue?vue&type=template&id=81257be2&"
import script from "./PageNotificationsView.vue?vue&type=script&lang=ts&"
export * from "./PageNotificationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports